<template>
  <div class="left-nav">
    <el-menu
      class="el-menu-vertical-demo"
      background-color="#545c64"
      :unique-opened="true"
      text-color="#fff"
      :default-active="curMenu"
      :router="true"
      active-text-color="#fff"
    >
      <!-- :default-active="$route.path" -->
      <template v-for="(item, index) in routes">
        <!-- 一级（根据有无子级渲染） -->
        <el-submenu v-if="item.meta&&item.children" :index="item.path" :key="index">
          <template slot="title">
            <span>{{item.meta.title}}</span>
          </template>
          <!-- 二级 -->
          <el-menu-item-group v-for="(item2, index2) in item.children" :key="index2">
            <el-menu-item :index="item2.path" :key="index2">{{item2.meta.title}}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <!-- 一级（根据有无子级渲染）-->
        <el-menu-item-group :key="index" v-if="!item.children&&item.meta">
          <el-menu-item :index="item.path" :key="index">{{item.meta.title}}</el-menu-item>
        </el-menu-item-group>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      curMenu: '',
      routes: this.$router.options.routes
    }
  },
  watch: {
    '$route': 'onActiveMenu'
  },
  mounted() {
    this.onActiveMenu()
  },
  methods: {
    onActiveMenu() {
      this.curMenu = this.cutStr(this.$route.path, '/', 4)
    },
    cutStr(str, findStr, num) { // 将字符串根据指定字符截取字符串
      var idx = str.indexOf(findStr)
      var count = 1
      while (idx >= 0 && count < num) {
        idx = str.indexOf(findStr, idx + 1)
        count = count + 1
      }
      if (idx < 0) {
        return ''
      }
      return str.substring(0, idx)
    }
  }
};
</script>

<style lang="scss" scoped>
.left-nav {
  z-index: 999999;
  height: 100%;
  width: 190px;
  background: #001c40;
  position: fixed;
  top: 60px;
  left: 0;
  bottom: 0;
  z-index: 999;
  ::v-deep .el-menu-item-group__title {
    display: none !important;
  }
  ::v-deep .el-submenu__title {
    padding: 0 !important;
    min-width: 190px !important;
    text-align: center;
    background: #052548 !important;
    span {
      margin-right: 20px;
    }
    i {
      right: 30px;
      top: 54%;
    }
  }
  ::v-deep .el-menu-item {
    padding: 0 !important;
    background: #001429 !important;
    min-width: 190px !important;
    text-align: center;
  }
  ::v-deep .el-menu-item.is-active {
    background: #0098e8 !important;
  }
  ::v-deep .el-menu {
    min-width: 190px;
  }
}
</style>